// `createStore` is deprecated in Redux 5 in favour of Redux Toolkit's
// `configureStore`; `legacy_createStore` is the same function without the
// deprecation warning. This store holds static gallery data only.
import { legacy_createStore as createStore } from 'redux';
import reducers from './reducers/index.js';

export const createAppStore = () => createStore(reducers);
